module.exports = __webpack_public_path__ + "img/camera.ca49c6a4.png";